import { createApiSlice } from "@common";
import { CRUD_SUB_SEGMENT } from "@routes";

const apiConfig = [
  {
    name: "addSubSegment",
    method: "post",
    url: CRUD_SUB_SEGMENT,
    stateKey: "message",
  },
  {
    name: "getSubSegment",
    method: "get",
    url: CRUD_SUB_SEGMENT,
    stateKey: "data",
  },
  {
    name: "updateSubSegment",
    method: "put",
    url: CRUD_SUB_SEGMENT,
    stateKey: "message",
  },
  {
    name: "deleteSubSegment",
    method: "delete",
    url: CRUD_SUB_SEGMENT,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "subSegment",
  apiConfig,
  customReducers);
const subSegmentSlice = slice;

export default subSegmentSlice.reducer;

export const {
  addSubSegment,
  getSubSegment,
  updateSubSegment,
  deleteSubSegment,
} = thunks;

export const { rowSelect } = actions;
